import { FC } from "react";
import { useMediaQuery } from "hooks/useMediaQuery";
import { Breakpoint } from "util/screen";
import "./style.scss";

const Sidebar: FC = ({ children }) => {
  const [isMd] = useMediaQuery(Breakpoint.md);
  return (
    <aside className="sidebar flex h-full bg-neutral-010">
      <div
        className="flex py-ld-16 flex-col h-full transition-bounds duration-150 ease-out overflow-hidden w-20 md:w-56"
        //   className={`flex p-ld-16 flex-col h-full bg-vibrant-cyan transition-bounds duration-150 ease-out overflow-hidden ${
        //     isMd ? "w-56" : "w-20"
        //   }`}
      >
        {children}
      </div>
    </aside>
  );
};

export default Sidebar;
